import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ChevronRight, Gift, Sparkles, User } from 'lucide-react';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import api from '@/lib/api';
import { useStore } from '@/context/StoreContext';

const EMPTY_TAXO = { rooms: [], styles: [], materials: [], categories: [], festivals: [], collections: [] };

const Section = ({ value, title, items }) => (
  <AccordionItem value={value} className="border-b border-border">
    <AccordionTrigger className="py-3 text-sm font-semibold">{title}</AccordionTrigger>
    <AccordionContent>
      <div className="grid grid-cols-2 gap-1 pb-2">
        {items.map((it) => (
          <Link key={it.to} to={it.to} className="rounded-lg px-2 py-2 text-sm text-foreground/80 hover:bg-[hsl(var(--gaze-ivory))]">{it.label}</Link>
        ))}
      </div>
    </AccordionContent>
  </AccordionItem>
);

export const MobileMenu = ({ open, onOpenChange }) => {
  const close = () => onOpenChange(false);
  const { isAuthed } = useStore();
  const [taxo, setTaxo] = useState(EMPTY_TAXO);
  useEffect(() => { api.get('/taxonomy').then((r) => setTaxo(r.data)).catch(() => {}); }, []);
  const wrap = (arr, base) => (arr || []).map((x) => ({ label: x.name, to: `${base}/${x.slug}` }));
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[88%] max-w-sm overflow-y-auto p-0" data-testid="mobile-menu">
        <div className="flex items-center justify-between bg-[hsl(var(--primary))] px-4 py-4 text-[hsl(var(--primary-foreground))]">
          <span className="font-display text-xl">Gaze Decor</span>
          <button onClick={close} data-testid="mobile-menu-close-button" aria-label="Close menu"><X size={20} /></button>
        </div>
        <div className="px-4 py-2" onClick={(e) => { if (e.target.tagName === 'A') close(); }}>
          <Link to={isAuthed ? '/account' : '/login'} className="my-2 flex items-center justify-between rounded-xl bg-[hsl(var(--gaze-ivory))] px-4 py-3 text-sm font-semibold" data-testid="mobile-account-link">
            <span className="flex items-center gap-2"><User size={16} className="gaze-gold" /> {isAuthed ? 'My Account' : 'Login / Sign Up'}</span>
            <ChevronRight size={16} />
          </Link>
          <Link to="/gift-finder" className="my-2 flex items-center justify-between rounded-xl bg-[hsl(var(--gaze-ivory))] px-4 py-3 text-sm font-semibold">
            <span className="flex items-center gap-2"><Gift size={16} className="gaze-gold" /> Gift Finder</span>
            <ChevronRight size={16} />
          </Link>
          <Link to="/inspiration" className="my-2 flex items-center justify-between rounded-xl bg-[hsl(var(--gaze-ivory))] px-4 py-3 text-sm font-semibold">
            <span className="flex items-center gap-2"><Sparkles size={16} className="gaze-gold" /> Inspiration Gallery</span>
            <ChevronRight size={16} />
          </Link>
          <Accordion type="single" collapsible className="w-full">
            <Section value="rooms" title="Shop by Room" items={wrap(taxo.rooms, '/rooms')} />
            <Section value="styles" title="Shop by Style" items={wrap(taxo.styles, '/style')} />
            <Section value="materials" title="Shop by Material" items={wrap(taxo.materials, '/material')} />
            <Section value="festival" title="Shop by Festival" items={wrap(taxo.festivals, '/festival')} />
            <Section value="collections" title="Collections" items={wrap(taxo.collections, '/collection')} />
            <Section value="categories" title="Categories" items={wrap(taxo.categories, '/category')} />
          </Accordion>
          <div className="mt-2 grid grid-cols-2 gap-2">
            <Link to="/colors" className="rounded-lg border border-border px-3 py-2 text-center text-sm">Shop by Color</Link>
            <Link to="/budget" className="rounded-lg border border-border px-3 py-2 text-center text-sm">Shop by Budget</Link>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;